export default "/bundles/assets/photo5_0ab734965544ac67f1c4d00729562113.png";